import ErrorPage from './_error';

export default function Custom403() {
  return <ErrorPage statusCode={403} />;
}
